import component from "./AuthContainer";
export default component;
